var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerViewOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 14.4H2.4C1.9584 14.4 1.6 14.0416 1.6 13.6V9.6C1.6 9.1584 1.9584 8.8 2.4 8.8H6.4C6.8416 8.8 7.2 9.1584 7.2 9.6V13.6C7.2 14.0416 6.8416 14.4 6.4 14.4Z",
    fill: "#505363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 7.20001H2.4C1.9584 7.20001 1.6 6.84161 1.6 6.40001V2.40001C1.6 1.95841 1.9584 1.60001 2.4 1.60001H6.4C6.8416 1.60001 7.2 1.95841 7.2 2.40001V6.40001C7.2 6.84161 6.8416 7.20001 6.4 7.20001Z",
    fill: "#505363"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 7.20001H9.6C9.1584 7.20001 8.8 6.84161 8.8 6.40001V2.40001C8.8 1.95841 9.1584 1.60001 9.6 1.60001H13.6C14.0416 1.60001 14.4 1.95841 14.4 2.40001V6.40001C14.4 6.84161 14.0416 7.20001 13.6 7.20001Z",
    fill: "#505363"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 14.4H9.6C9.1584 14.4 8.8 14.0416 8.8 13.6V9.6C8.8 9.1584 9.1584 8.8 9.6 8.8H13.6C14.0416 8.8 14.4 9.1584 14.4 9.6V13.6C14.4 14.0416 14.0416 14.4 13.6 14.4Z",
    fill: "#505363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerViewOn);
export default __webpack_public_path__ + "static/media/banner-view-on.fcf601a47c49fbd9bdaf70623405b519.svg";
export { ForwardRef as ReactComponent };